import React, { useEffect, useState } from 'react'

import axios from 'axios';
import { DragDropContext } from 'react-beautiful-dnd';
import { Box, Stack, Typography, Grid } from '@mui/material'

import { Input, Chip, Accordion, AccordionSummary, AccordionDetails} from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Droppable } from 'react-beautiful-dnd';

import StudentInfoCard from '../StudentInfoCard/StudentInfoCard';
import StudentInfoSidebar from '../StudentInfoSidebar/StudentInfoSidebar';
import Group from './Group';

const GroupsList = (props) => {
  const [ groups, setGroups ] = useState(props.groups);
  const [ unsorted, setUnsorted ] = useState({});
  // Need to figure out a way to better manage the list of students and their information
  const [ completed, setCompleted ] = useState(props.completed); // list of students that have completed assignment1 
  const [ incomplete, setIncomplete ] = useState(props.incomplete); // list of students that have not completed assignment1
  const [ show, setShow ] = useState(false);
  const [ information, setInformation ] = useState({});
  const [ expand, setExpand ] = useState(props.expandAll);
    
  const handleIndividualExpand = (event) => {
      setExpand(!expand)
    }

  const studentInfoTab = (student) => {
    setShow(true);
    const information = props.studentDetails.filter((info) => info.user_id === student.user_id)[0];
    setInformation(information)
  }

  const closeSidebar = () => {
    setShow(false);
  }

  const handleCapacity = async (project) => {
    await axios.put(`${process.env.REACT_APP_API_HOST}/api/projects/updateCapacity/${project.project_id}`, project, 
    {
      headers: {Authorization: `Bearer ${props.token.access_token}`}
    });
  }

  const handleDragStart = () => {
    // props.setExpandAll(true);
    // props.setExpandAll(false);
  }
  //logic for reordering and placement
  const handleDragEnd = ({destination, source}) => { 
    // props.setExpandAll(true);

    if (!destination){
        console.log("Not dropped in a droppable zone")
        return
    }
    else if (destination.droppableId === source.droppableId){
        //reordering group
        const index = groups.map(project => project.project_id).indexOf(parseInt(source.droppableId));
        const copyStudent = groups.filter((project) => project.project_id === parseInt(source.droppableId))[0].users[source.index] ;
        groups[index].users.splice(source.index, 1);        
        groups[index].users.splice(destination.index, 0, copyStudent);        
        setGroups(groups);
        window.sessionStorage.setItem("groups" + props.class_id, JSON.stringify(groups));
        return
    }
    else {
        const fromIndex = groups.map(project => project.project_id).indexOf(parseInt(source.droppableId));
        const toIndex = groups.map(project => project.project_id).indexOf(parseInt(destination.droppableId));
        const copyStudent = groups.filter((project) => project.project_id === parseInt(source.droppableId))[0].users[source.index] ;

        groups[fromIndex].users.splice(source.index, 1);        
        groups[toIndex].users.splice(destination.index, 0, copyStudent);     
        window.sessionStorage.setItem("groups" + props.class_id, JSON.stringify(groups));   
        setGroups(groups);
    }
  }

  useEffect(() => {
    setCompleted(props.completed);
    setIncomplete(props.incomplete);
  }, [props.completed, props.incomplete])

  useEffect(() => {
    setGroups(props.groups);
  }, [props.groups])

  useEffect(() => {
    setExpand(props.expandAll)
  }, [props.expandAll])

  return (
    <div>
      <Grid item xs={show ? 8 : 11} md={show ? 8 : 12}>
        { groups.length > 0 ?
          <Box sx={{ p: 2}}>
            <DragDropContext onDragEnd={handleDragEnd} onBeforeCapture={handleDragStart}>
              {/* drag and drop formations and stats */}
              <Droppable key={groups[0].project_id} droppableId={groups[0].project_id.toString()}>
                  {(provided) => (
                  <div ref={provided.innerRef} {...provided.droppableProps} 
                    style={{ marginBlock: 10 }}>
              
                  <Accordion 
                      key={groups[0].project_id} 
                      defaultExpanded={props.expandAll}
                      defaultValue={expand}
                      sx={groups[0].project_id === 0 ? 
                        { boxShadow: 4 , backgroundColor: '#474747' } 
                        : 
                        { boxShadow: 4}} 
                      expanded={expand} 
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon/>}
                      aria-controls="panel1a-content"
                      onClick={handleIndividualExpand}
                    >
                      <Typography 
                        style={groups[0].project_id === 0 ? { width:'50%', color: 'white'} : { width:'50%'}} 
                        variant="h5"
                      >
                          {groups[0].name}
                      </Typography>
                      <div>
                        {groups[0].project_id !== 0 ? 
                          <Stack direction="row" spacing={4} alignItems="center">
              
                          <Typography style={{ width:'40%' }}>
                          {"#1 votes: " + 
                          (props.projectRanking
                          && props.projectRanking.has(groups[0].project_id) && props.projectRanking.get(groups[0].project_id)[1]
                          ? props.projectRanking.get(groups[0].project_id)[1].length
                          : 0)}
                            </Typography>
                            <div style={{display: "flex", width: "30%"}}>
                              <Typography>Size: </Typography>
                              <Input
                                type='number'
                                size="small"
                                inputProps={{min: 0, style:{padding: 0, marginInlineStart: "4px", width: "38px"}}}
                                defaultValue={groups[0].capacity}
                                onClick={(event)=> event.stopPropagation()}
                                onBlur={(data) => {
                                  
                                  if (data.target.value) {
                                    if (data.target.value < 0)
                                      data.target.value = 0
                                      groups[0].capacity = parseInt(data.target.value);
                                  }
                                  else
                                  groups[0].capacity = 0;
                                  handleCapacity(groups[0]);
                                }}
                              />
                            </div>
                          <Chip label={groups[0].end_semester} size='small'/>
                          </Stack>
                          : null
                          }
                        </div>
                    </AccordionSummary>
                    <AccordionDetails sx={groups[0].project_id === 0 ? {overflow: 'auto', height: '30vh'} : {}} >
                     {/* <Divider style={{marginBlockStart:"5px", }}/> */}
                        {groups[0].users.map((student, i) =>(
                          <StudentInfoCard
                            index={i}
                            student={student}
                            project_id={groups[0].project_id}
                            projectRanking={
                            (props.studentRankings
                            && props.studentRankings.has(student.user_id) 
                            && (props.studentRankings.get(student.user_id).get(groups[0].project_id))) 
                            || "Unranked"}
                            handleOpen={() => studentInfoTab(student)}
                            key={student.user_id}
                            locked={props.handleLockList}
                            lockedList={props.lockedList}
                          />
                        ))}
                        {/* makes a place for the new droppable to be dropped */}
                        {provided.placeholder}
              
                    </AccordionDetails>
                  </Accordion>
                  </div>
                )}
                </Droppable>

              <Box sx={expand ? {overflowY: "auto", maxHeight: '50vh',  p: 1, bottom: 0} : {overflowY: "auto", maxHeight: '83vh',  p: 1, bottom: 0}}>
                {groups.map((project) => (
                  <div key={project.project_id}>
                    {project.project_id === 0 ? null:
                    
                      <Group 
                        project={project} 
                        handleCapacity={handleCapacity} 
                        studentInfoTab={studentInfoTab} 
                        projectRankings={props.projectRankings}
                        groups={props.groups}
                        expandAll={props.expandAll}
                        studentDetails={props.studentDetails}
                        studentRankings={props.studentRankings}
                        projectRanking={props.projectRankings}
                        handleLockList={props.handleLockList}
                        lockedList={props.lockedList}
                        token={props.token}
                      />                    

                    }
                  </div>
                ))}

              </Box>
            </DragDropContext>
          </Box>
          :
          <Box sx={{overflowY: "auto", maxHeight: "94vh", p: 1}}>
            <Typography variant="h5" style={{marginBlock: 10}}>Incomplete</Typography>
            {incomplete.map((student) => (
                <Stack key={student.user_id} onClick={() => studentInfoTab(student)} direction='row' spacing={1} style={{backgroundColor:'#ECF7FF', padding: "0.8rem", borderRadius: 3, alignItems: 'center', justifyContent: "space-between", marginBottom: "7px"}}>
                  <Stack direction="row" sx={{width: "100%"}}>
                      <Typography style={{ width:'45%' }} >{student.first_name + " " + student.last_name}</Typography>
                      {/* <Typography style={{ width:'15%' }} >{student.studentRankingInfo.end_semester}</Typography> */}
                  </Stack>
                </Stack>
            ))}
            <Typography variant="h5" style={{marginBlock: 10, marginTop: 20}}>Complete</Typography>
            {completed.map((student) => (
                <Stack key={student.user_id} onClick={() => studentInfoTab(student)} direction='row' spacing={1} style={{backgroundColor:'#ECF7FF', padding: "0.8rem", borderRadius: 3, alignItems: 'center', justifyContent: "space-between", marginBottom: "7px"}}>
                  <Stack direction="row" sx={{width: "100%"}}>
                      <Typography style={{ width:'45%' }} >{student.first_name + " " + student.last_name}</Typography>
                      <Typography style={{ width:'15%' }} >{student.studentRankingInfo.end_semester}</Typography>
                  </Stack>
                </Stack> 
            ))}
          </Box>
        }
      </Grid>
      <Grid item>
        <StudentInfoSidebar 
          student={information}
          open={show}
          handleClose={closeSidebar}
          studentRankings={props.studentRankings}
          projectRanking={props.projectRankings}
        />
      </Grid>
    </div>
  )
}

export default GroupsList